"use client";

import { Amplify } from "aws-amplify";
import { fetchAuthSession } from "aws-amplify/auth";
import { getAmplifyConfig } from "@/aws.config";

const amplifyConfig = getAmplifyConfig();

Amplify.configure(amplifyConfig, {
  ssr: true,
  API: {
    GraphQL: {
      headers: async () => ({
        Authorization: (
          await fetchAuthSession()
        ).tokens?.idToken?.toString() as string,
      }),
    },
  },
});

export default function AmplifyConfig() {
  return null;
}
